import { useThemeStore } from '../store/themeStore';
import { getDesignTokens } from '../utils/designTokens';

interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
  label?: string;
}

const sizeClasses = {
  sm: 'h-4 w-4 border-2',
  md: 'h-5 w-5 border-2',
  lg: 'h-6 w-6 border-[3px]',
};

export default function LoadingSpinner({
  size = 'md',
  className = '',
  label = 'Loading',
}: LoadingSpinnerProps) {
  const { isDarkMode } = useThemeStore();
  const tokens = getDesignTokens(isDarkMode);
  const spinnerClass = sizeClasses[size];

  return (
    <span className={`inline-flex items-center gap-2 ${className}`} aria-label={label} role="status">
      <span
        className={`${spinnerClass} animate-spin rounded-full border-current border-t-transparent ${tokens.text.primary}`}
      />
      <span className="sr-only">{label}</span>
    </span>
  );
}
